import React from "react";
import { motion } from "framer-motion";
import { Bio } from "../../data/constants";
import {
  HeroContainer,
  Stars,
  Moon,
  Ridge,
  HeroInner,
  Eyebrow,
  Title,
  TitleRow,
  TitleOrange,
  TitleWhite,
  Intro,
  ScrollCue,
  StarCluster,
} from "./HeroStyle";
import StarMark from "../common/StarMark";
import { revealLine, SNAP } from "../../utils/motion";

const container = {
  hidden: {},
  show: { transition: { staggerChildren: 0.11, delayChildren: 0.1 } },
};

const item = {
  hidden: { opacity: 0, y: 18 },
  show: { opacity: 1, y: 0, transition: { duration: 0.55, ease: SNAP } },
};

// The scroll cue keeps nudging after the entrance, so the fold never sits dead.
const cue = {
  hidden: { opacity: 0, y: 10 },
  show: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.5, ease: SNAP, delay: 0.55 },
  },
};

// Split "Vivek Marakumbi" into the objective's two-line treatment: first name
// orange on line 1, surname white on line 2.
const [firstName, ...restName] = Bio.name.split(" ");
const lastName = restName.join(" ");

// Three flat hill silhouettes, back to front. Percentages are clip-path
// polygon points — hard edges only, no curves and no gradient fill.
const RIDGES = [
  {
    h: "34%",
    bg: "#0d1f16",
    clip:
      "polygon(0% 42%, 12% 26%, 24% 38%, 38% 18%, 52% 34%, 66% 22%, 80% 36%, 92% 24%, 100% 34%, 100% 100%, 0% 100%)",
  },
  {
    h: "24%",
    bg: "#0d2415",
    clip:
      "polygon(0% 48%, 15% 30%, 30% 44%, 46% 26%, 60% 42%, 74% 30%, 88% 46%, 100% 32%, 100% 100%, 0% 100%)",
  },
  { h: "12%", bg: "#111a0d", clip: "polygon(0% 40%, 100% 22%, 100% 100%, 0% 100%)" },
];

const ArrowDown = () => (
  <svg width="14" height="20" viewBox="0 0 14 20" aria-hidden="true">
    <path
      d="M7 0 V16 M1 11 L7 18 L13 11"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
    />
  </svg>
);

const HeroSection = () => (
  <HeroContainer id="home">
    <Stars aria-hidden="true" />
    <Moon aria-hidden="true" />
    {RIDGES.map((r, i) => (
      <Ridge key={i} $h={r.h} $bg={r.bg} $clip={r.clip} aria-hidden="true" />
    ))}

    <HeroInner variants={container} initial="hidden" animate="show">
      <Eyebrow variants={item}>AI Engineer</Eyebrow>

      <Title>
        <TitleRow>
          <TitleOrange variants={revealLine}>{firstName}</TitleOrange>
        </TitleRow>
        {lastName && (
          <TitleRow>
            <TitleWhite variants={revealLine}>{lastName}</TitleWhite>
          </TitleRow>
        )}
      </Title>

      <Intro variants={item}>I build retrieval and agent systems, then test where they fail.</Intro>

      <ScrollCue variants={cue} href="#about">
        Begin reading
        <motion.span
          animate={{ y: [0, 6, 0] }}
          transition={{ duration: 1.8, repeat: Infinity, ease: "easeInOut" }}
        >
          <ArrowDown />
        </motion.span>
      </ScrollCue>
    </HeroInner>

    <StarCluster aria-hidden="true">
      <StarMark size={64} />
    </StarCluster>
  </HeroContainer>
);

export default HeroSection;
